import _ from "lodash";

export const assignToDomainObject = <T>(domainObj: T, dataToAssign: object, keys: Array<keyof T>): T => {
	return Object.assign(domainObj, _.pick(dataToAssign, keys));
};
